import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class DeliveryNotificationsService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  obtenerOrdenesCompra(userProveedorId, iPagina): Observable<any> {
    const num_proveedor = userProveedorId;
    const pagina = iPagina;
    const dias_atras = '100';
    const tipo_de_operacion = 'E';

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', num_proveedor)
      .set('pagina', pagina)
      .set('dias_atras', dias_atras)
      .set('tipo_de_operacion', tipo_de_operacion)
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  buscarOrdenesCompra(userProveedorId, iPagina): Observable<any> {
    const num_proveedor = userProveedorId;
    const pagina = iPagina;
    const dias_atras = '100';
    const tipo_de_operacion = 'E';

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', num_proveedor)
      .set('pagina', pagina)
      .set('dias_atras', dias_atras)
      .set('tipo_de_operacion', tipo_de_operacion)
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  busquedaOrdenesCompra(proveedor, ordenCompra, sociedadOpc) {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('num_proveedor', proveedor)
      .set('orden_de_compra', ordenCompra)
      .set('referencia', '')
      .set('sociedad', sociedadOpc)
      .set('tipo_de_operacion', 'E')
    };
    return this.http.get(this.basePath + 'Proveedores-facturas/OrdenesDeCompra', options);
  }

  obtenerPosicionOC(idOrden): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('idOrdenCompra', idOrden)
    };
     return this.http.get(this.basePath +
     'posicionOcAsn', options);
  }

  generarXML(idOrden): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'text/html');
    const options = {
      headers: httpHeaders,
      params: new HttpParams()
      .set('idOrdenCompra', idOrden)
    };
     return this.http.get(this.basePath +
     'posicionOcAsn/generarXmlOC?idOrdenCompra=' + idOrden, {responseType: 'text'});
  }

  envioXML(data): Observable<any> {
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'posicionOcAsn/carga', data, options);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/delivery-notifications/delivery-notifications.service.ts